module.exports = __webpack_public_path__ + "static/media/tw.b2bda896.svg";